import React, { useState } from "react";

import styles from "./KCard.module.css";

import { collection, doc, setDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import ButtonSave from "./Buttons/ButtonSave";
import LoadingSpinner from "./LoadingSpinner";
import KCardImagePagination from "./KCardImagePagination";
import IconVolumeUp from "./Icons/IconVolumeUp";

const KCard = function (props) {
  const [isSaving, setIsSaving] = useState(false);
  const [isSaved, setIsSaved] = useState(false);

  const handleResultChange = function (e) {
    props.onResultChange(e.target.value);
  };

  const handleQueryChange = function (e) {
    props.onQueryChange(e.target.value);
  };

  const handleInfoChange = function (e) {
    props.onInfoChange(e.target.value);
  };

  const onSubmitHandler = async function (e) {
    e.preventDefault();
    setIsSaving(true);

    const user = auth.currentUser.uid;
    const imgUrl = props.img;
    const query = props.query;
    const result = props.result;
    const info = props.info;
    const inputLang = props.inputLang;
    const outputLang = props.outputLang;
    const kRank = null;

    let kcard;
    try {
      const docRef = await doc(collection(db, "kcards"));
      kcard = {
        id: docRef.id,
        user,
        imgUrl,
        query,
        result,
        info,
        inputLang,
        outputLang,
        kRank,
      };
      await setDoc(docRef, kcard);
      // update local collection
      props.updateLocalCollection((prev) => [...prev, kcard]);
      // clear card
      props.onClear();
    } catch (error) {
      console.error("Error adding document: ", error);
      setIsSaving(false);
    }
    setIsSaving(false);
    setIsSaved(true);
    setTimeout(() => {
      setIsSaved(false);
    }, 2000);
  };

  const playTTS = function () {
    var source = `https://translate.google.com/translate_tts?tl=${
      props.outputLang
    }&q=${encodeURIComponent(props.result)}&client=tw-ob`;
    var audio = new Audio(source);
    audio.play();
  };

  if (props.static) {
    return (
      <div
        className={styles.kcard}
        data-kcard={JSON.stringify({
          id: props.kcardId,
          imgUrl: props.img,
          result: props.result,
          query: props.query,
          info: props.info,
        })}
      >
        <div className={styles["kcard-img"]}>
          <img src={props.img} alt="" loading="lazy" className={styles.img} />
        </div>

        <div className={styles["static-content"]}>
          <div className={styles["kcard-text"]}>
            <p className={styles["kcard-text__input--lg"]}>{props.result}</p>
            <p className={styles["kcard-text__input--md"]}>{props.query}</p>
            <p className={styles["kcard-text__input--sm"]}>{props.info}</p>
          </div>
        </div>

        <button className={styles.volume} onClick={playTTS} data-volume>
          <IconVolumeUp />
        </button>
      </div>
    );
  }

  return (
    <form
      className={styles.kcard}
      onSubmit={onSubmitHandler}
      autoComplete="off"
    >
      {isSaving && (
        <div className={styles["status-indicators"]}>
          <LoadingSpinner className={styles.saving} />
        </div>
      )}
      {!isSaving && isSaved && (
        <div className={styles["status-indicators"]}>
          <p className={styles["card-saved"]}>Card saved ✓</p>
        </div>
      )}
      <div className={styles["kcard-img"]}>
        {!props.isLoading && (
          <KCardImagePagination
            img={props.img}
            imageSearch={props.imageSearch}
            onImageChange={props.onImageChange}
          />
        )}
        {props.isLoading && <LoadingSpinner />}
      </div>

      <div className={styles.content}>
        <div className={styles["kcard-text"]}>
          <input
            id="result"
            className={`${styles["kcard-text__input"]} ${styles["kcard-text__input--lg"]}`}
            type="text"
            placeholder="Result"
            value={props.result}
            onChange={handleResultChange}
          ></input>
          <input
            id="query"
            className={`${styles["kcard-text__input"]} ${styles["kcard-text__input--md"]}`}
            type="text"
            placeholder="Query"
            value={props.query}
            onChange={handleQueryChange}
          ></input>
          <input
            id="info"
            className={`${styles["kcard-text__input"]} ${styles["kcard-text__input--sm"]}`}
            type="text"
            placeholder="Additional information"
            value={props.info}
            onChange={handleInfoChange}
          ></input>
        </div>
        <button className={styles.volume} onClick={playTTS} type="button">
          <IconVolumeUp />
        </button>
        <ButtonSave disabled={isSaving}>SAVE CARD</ButtonSave>
      </div>
    </form>
  );
};

export default KCard;
